<style>
    textarea {
        height: auto;
        padding: 16px 27px 16px;
        width: 100%;
        background-color: transparent;
        outline: 0;
        color: #838383;
        font-size: 16px;
        border: 2px solid #d5d5d5;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        letter-spacing: -0.5px;
        font-family: 'Verdana', Helvetica, Arial, sans-serif;
    }
</style>

<template>
    <div>

        <div class="positie_z clearfix" v-show="offerproducts.length == 0 && orderproducts.length == 0">
            <div class="positie_z_inner">

                <p style="padding: 10px 30px 40px;">
                    Je hebt nog geen kwaliteiten in je winkelwagen, bekijk kwaliteiten via de <a href="/staalwijzer">staalwijzer</a>. Of bestel direct via de <a href="/specificeren/voorbewerkt/st-52-3-1.0570-gereedschapsstaal-precisie-voorgeslepen-smeedstukken-op-maat-bewerkt">webshop</a>.
                </p>
            </div>
        </div>

        <div class="positie_z clearfix" v-show="residualProducts.length > 0 || orderproducts.length > 0 || offerproducts.length > 0">
            <div class="positie_z_inner">
                <p style="padding: 10px 30px">
                    Om snel en makkelijk online te kunnen bestellen, heeft u een account nodig. Klik  <a class="login-popup-btn" style="text-decoration: underline; cursor: pointer">hier</a> om in te loggen of een nieuw account aan te maken.
                </p>
            </div>
        </div>

        <h4 v-show="orderproducts.length > 0 ">Bestellen</h4>

        <productlijst :products="orderproducts" :customer="customer"></productlijst>


        <h4 v-show="residualProducts.length > 0 ">Rest voorraad</h4>

        <productlijst :products="residualProducts"></productlijst>

        <h4 v-show="offerProductsWithoutResidualProducts.length > 0 ">Offerte</h4>

        <productlijst :products="offerProductsWithoutResidualProducts"></productlijst>


        <div class="positie_z clearfix" v-show="offerproducts.length > 0 || orderproducts.length > 0">
            <div class="positie_z_inner flot_rit">
                <!--<p>Totaal</p>-->
                <p class="prize_ut flot_lft">Subtotaal: </p> <p class="prize_ut flot_rit">€{{totalPrice}}</p>
                <div class="clear"></div>

                <div v-if="hasCustomer">
                    <p class="prize_ut flot_lft" >Kortingspercentage: <small class="small_ex_btw">({{discountPercentage.toFixed(0)}}%)</small></p> <p class="prize_ut flot_rit">€{{discountWithoutResidualProducts}}</p>
                    <div class="clear"></div>
                </div>

                <p class="prize_ut flot_lft">Totaal: <small class="small_ex_btw">(exclusief BTW)</small></p><p class="prize_ut flot_rit">€{{(totalPrice - discountWithoutResidualProducts).toFixed(2)}}</p>
                <div class="clear"></div>
                <br>

                <div v-if="! hasCustomer">
                    <p class="prize_ut flot_lft">Naam: <small class="small_ex_btw">(Verplicht)</small>  <input style="width: 122%; margin: 10px 0 10px 0;" class="form-field" type="text" name="name" v-model="customerName" /></p>
                    <div class="clear"></div>
                    <p class="prize_ut flot_lft">Bedrijf:  <input style="width: 140%; margin: 10px 0 10px 0;" class="form-field" type="text" name="company" v-model="customerCompany" /></p>
                    <div class="clear"></div>
                    <p class="prize_ut flot_lft" v-if="offerProductsWithoutResidualProducts.length > 0">Telefoonnummer:  <small class="small_ex_btw">(Verplicht)</small> <input style="width: 105%; margin: 10px 0 10px 0;" class="form-field" type="text" name="phone" v-model="customerPhone" /></p>
                    <div class="clear"></div>
                    <p class="prize_ut flot_lft">Email: <small class="small_ex_btw">(Verplicht)</small>  <input style="width: 125%; margin: 10px 0 10px 0;" class="form-field" type="email" name="email" v-model="customerEmail" /></p>
                    <div class="clear"></div>
                </div>


                <p class="prize_ut flot_lft">Referentienummer:  <input style="margin: 10px 0 0px 0;" class="form-field" type="text" name="refNr" v-model="refnr" /></p>
                <div class="clear"></div>
                <small class="small_ex_btw" style="margin-bottom:10px;">(indien niet aanwezig is een '-' of '.' voldoende)</small>
                <br>
                <p class="prize_ut flot_lft">Opmerking: <br><textarea style="margin: 10px 0 10px 0;" v-model="note" name="note" cols="44" rows="10"></textarea>
                <div class="clear"></div>
                <button v-bind:disabled="finishAvailable" @click="submitOrder()" class="order_btn_z btn_orange">AFHANDELEN</button>
            </div>
        </div>
    </div>
</template>

<script>

    var SortedArray = require("collections/sorted-array");


    let auth = document.head.querySelector('meta[name="auth"]').content;


    import customerShoppingCart from './helpers/cart/customer';
    import guestShoppingCart from './helpers/cart/guest';

    let mixin = guestShoppingCart;

    if (parseInt(auth)) {
        mixin = customerShoppingCart;
    }

    export default {
        mixins: [mixin],
        props: {
            products: {Array},
            discountPercentage: {Number, default: 0},
            customer: {Object}
        },
        data: function() {
            return {
                orderlines: new SortedArray(),
                guestOrderLines: [],
                posting: false,
                refnr: "",
                note: "",
                customerName: "",
                customerCompany: "",
                customerEmail: "",
                customerPhone: "",
            }
        },
        created: function() {
            this.orderlines = this.products;
        },
        mounted: function(){
            WinkelwagenEventBus.$on('winkelwagen-changeOrderType', (order) => {
                this.changeOrderLine(order);
            });
            WinkelwagenEventBus.$on('disable-radios', () => {
                this.posting = true;
            });
            WinkelwagenEventBus.$on('enable-radios', () => {
                this.posting = false;
            });
            WinkelwagenEventBus.$on("winkelwagen-remove-orderline", (order) => {
                this.removeOrderLine(order);
            });
        },
        methods: {
            round: function(value, precision) {
                var multiplier = Math.pow(10, precision || 0);
                return Math.round(value * multiplier) / multiplier;
            }
        },
        computed: {
            hasCustomer: function() {
                return (this.customer);
            },
            discountText: function(){
                return (this.discountPercentage > 0) ? 'U ontvangt een korting van ' + this.discountPercentage + '%' : '' ;
            },
            residualProducts: function(){
                return this.offerproducts.filter(product =>  (product.residual_product_id || product.is_residual_product));
            },
            offerProductsWithoutResidualProducts: function(){
                return this.offerproducts.filter(function(product) {
                    if(product.residual_product_id) {
                        return false;
                    }
                    return (! product.is_residual_product)
                });
            },
            discountWithoutResidualProducts: function(){
                var sum = this.totalPrice;
                this.offerproducts.forEach(function(product) {
                    if(product.residual_product_id) {
                        sum = sum - product.price_per_piece ;
                    }
                });
                return (sum / 100 * parseFloat(this.discountPercentage).toFixed(0)).toFixed(2);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/winkelwagen.vue